export default __webpack_public_path__ + "static/media/Demo_Header_Logo.c701efe3.png";